// Bridges the router and the Rumio host URL (lib/host-nav.ts). Render once
// inside the router.

import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { startHostNav, type HostNav } from '../lib/host-nav';

export function HostNavSync(): null {
  const navigate = useNavigate();
  const location = useLocation();
  const nav = useRef<HostNav | null>(null);

  useEffect(() => {
    nav.current = startHostNav((path) => navigate(path));
    return () => nav.current?.stop();
  }, [navigate]);

  useEffect(() => {
    nav.current?.announce(`${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);

  return null;
}
